// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hryzy","placeholdersHeader":"styles_placeholdersHeader__8n45A","editorStyle":"styles_editorStyle__1II8q","placeholdersBox":"styles_placeholdersBox__1aBGI"};